import { gql } from "@apollo/client";

export const SEND_STOCKPILES_TABLE_DATA = gql`
  mutation SaveInput(
    $stockpileName: String!
    $startDate: String!
    $endDate: String!
    $userInfo: UserInfoType!
    $featuresData: FeaturesInputType!
  ) @api(name: "cosmos") {
    saveMatchingInputRequest(
      inputData: {
        stockpileName: $stockpileName
        startDate: $startDate
        endDate: $endDate
        userInfo: $userInfo
        featuresData: $featuresData
      }
    ) {
      requestId
    }
  }
`;

export const SEND_INCLUDE_IN_FORECAST = gql`
  mutation IncludeInForecast(
    $stockpileId: String!
    $requestId: String!
    $userInfo: UserInfoType!
    $inputStockpile: String!
  ) @api(name: "cosmos") {
    includeInForecast(
      stockpileData: {
        stockpileId: $stockpileId
        requestId: $requestId
        userInfo: $userInfo
        inputStockpile: $inputStockpile
      }
    ) {
      inputStockpile
    }
  }
`;

export const SEND_CREATE_FORECAST = gql`
  mutation CreateForecast(
    $notes: String!
    $userInfo: UserInfoType!
    $includedStockpiles: [InputTypeForIncludedStockpile!]!
    $monthId: String!
  ) @api(name: "cosmos") {
    createForecast(
      forecast: {
        notes: $notes
        userInfo: $userInfo
        includedStockpiles: $includedStockpiles
        monthId: $monthId
      }
    ) {
      forecastId
      id
    }
  }
`;

export const SEND_UPDATE_FORECAST = gql`
  mutation UpdateForecast(
    $notes: String!
    $userInfo: UserInfoType!
    $forecastId: String!
    $id: ID!
    $includedStockpiles: [InputTypeForIncludedStockpile!]!
    $monthId: String!
  ) @api(name: "cosmos") {
    updateForecast(
      forecast: {
        notes: $notes
        userInfo: $userInfo
        includedStockpiles: $includedStockpiles
        forecastId: $forecastId
        id: $id
        monthId: $monthId
      }
    ) {
      forecastId
      id
    }
  }
`;
